export default "__VITE_ASSET__b65dabfb__"